import React, { FunctionComponent } from 'react';
import { ForgeIcon, ForgeTooltip } from '@tylertech/forge-react';
import { I18n } from 'common/i18n';
import './PrivateFieldIcon.scss';

const t = (k: string, scope = 'shared.dataset_management_ui') => I18n.t(k, { scope });
const PrivateFieldIcon: FunctionComponent = () => {
  return (<>
    <ForgeIcon className='private-field-icon' name="lock" slot="leading" />
    <ForgeTooltip placement="right">
      {t('private_icon_tooltip')}
    </ForgeTooltip>
  </>);
};

export default PrivateFieldIcon;
